import { Component, inject, OnInit, ChangeDetectorRef, HostListener, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { MdlCall } from '../../components/mdl-call/mdl-call';
import { MdlTask } from '../../components/mdl-task/mdl-task';
import { MdlEvent } from '../../components/mdl-event/mdl-event';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute,Router } from '@angular/router';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { NavOpportunities } from '../../components/opportunities/nav-opportunities/nav-opportunities';
import { AlertService } from '../../services/alert.service';
import { MdlChangeOwnerComponent } from '../../components/mdl-change-owner/mdl-change-owner';
import { OpportunityService } from '../../services/opportunity.service';
import { PermissionService } from '../../services/permission.service';
import { MdlCloseOpportunity } from '../../components/mdl-close-opportunity/mdl-close-opportunity';
import { FormsModule } from '@angular/forms';
import { MdlSendMail } from '../../components/mdl-send-mail/mdl-send-mail';
import { MdlNewEventComponent } from '../../components/mdl-new-event/mdl-new-event';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';

@Component({
  selector: 'app-opportunities-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    NavOpportunities,
    FormsModule,
  ],
  templateUrl: './opportunities-detail.html',
  styleUrl: './opportunities-detail.css'
})

export class OpportunitiesDetail implements OnInit {
  public oportunidad: any = null;
  public api = inject(Api);
  public isLoading: boolean = true;
  public errorMessage: string = '';
  public oportunidadId: string = '';
  public oppStatus: any = [];
  public markedStatus: string = '';

  readonly dialog = inject(MatDialog);
  private alertService = inject(AlertService);

  openedMenuId: string | null = null;
  showRecentDropdown: boolean = false;


  public oppSteps: any = [];
  public oppService = inject(OpportunityService);
  public showInfoSection: boolean = true;
  public showExtraSection: boolean = true;
  public showOtherSection: boolean = true;
  public showHistorySection: boolean = true;

  public editInfo: boolean = false;
  public editExtra: boolean = false;

  public editableOportunidad: any = {};

  public currentStep: number = 0;
  public progreso_estado : any = [];
  private statusIndex: number = -1;

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    public permissionService:PermissionService,
    private router:Router
  ) {
    
  }

  ngOnInit(): void {
    this.getOppSteps();
    this.getProspectStatus();
    this.route.params.subscribe(params => {
      this.oportunidadId = params['id'];
      if (this.oportunidadId) {
        this.loadOportunidad(this.oportunidadId);
      } else {
        this.errorMessage = 'No se proporcionó un ID de oportunidad válido';
        this.isLoading = false;
      }
    });
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;
    
    const clickedInsideRecent = this.elementRef.nativeElement.querySelector('.dropdown-trigger')?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement.querySelector('.dots-button')?.contains(target);
    
    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }
    
    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }

 
  loadOportunidad(id: string): void {
    this.isLoading = true;
    this.errorMessage = '';
    
    this.api.getOportunidad( id ).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response?.oportunidad) {
          this.oportunidad = response.oportunidad;
          this.progreso_estado = response.progreso_estados;
          console.log(this.progreso_estado);
          this.formatOportunidadData();
        } else {
          this.errorMessage = response?.message || 'No se encontraron datos de la oportunidad';
        }
        this.cdr.detectChanges(); 
      },
    error: (err: any) => {
      console.error("Error en API:", err);

      if (err.status === 403) {
        this.errorMessage = "No tienes permiso para ver esta oportunidad.";
        this.router.navigateByUrl("/opportunities");

      } else {
        this.errorMessage = "Error al cargar la oportunidad.";
      }

      this.isLoading = false;
      this.api.hideLoading();
    }
    });
  }
        

 private formatOportunidadData(): void {
  if (this.oportunidad.fecha_cierre_estimada) {
    this.oportunidad.fecha_cierre_formatted =
      this.formatDateString(this.oportunidad.fecha_cierre_estimada);
  }
  
    
    if (this.oportunidad.monto_estimado) {
      this.oportunidad.monto_formatted = 
        'CLP ' + new Intl.NumberFormat('es-CL').format(this.oportunidad.monto_estimado);
    }
    
    if (this.oportunidad.probabilidad_cierre) {
      this.oportunidad.probabilidad_formatted = 
        Math.round(this.oportunidad.probabilidad_cierre) + '%';
    }
  }
  saveOportunidad(): void {
    this.isLoading = true;
    this.api.updateOportunidad(this.oportunidad).subscribe({
      next: (response) => {
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = 'Error al guardar la oportunidad';
        this.isLoading = false;
      }
    });
  }


  openNewCall(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.oportunidad,
        mode: 'call',
        tipo: 'OPP',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewTask(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.oportunidad,
        mode: 'task',
        tipo:'OPP'
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewEvent(): void {
    this.dialog.open(MdlNewEventComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        relacionado: this.oportunidad,
        tipo: 'OPP'
      }
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openChangeOwner(): void {
    const dialogRef = this.dialog.open(MdlChangeOwnerComponent, {
      minWidth: '750px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: { 
        entityData: this.oportunidad,
        entityType: 'opportunity' 
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        this.loadOportunidad(this.oportunidadId);
        this.alertService.success('Propietario actualizado', 'Propietario actualizado correctamente');
      }
    });
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  openNewfilterActivities(): void {
    this.dialog.open(Mdlfilterectivities, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class'
    });
  }

  openMdlDeleteOpportunity(id: string) {
    const dialogRef = this.dialog.open(MdlDelete, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'opportunity',
        id: id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        this.alertService.success('Oportunidad eliminada', 'Oportunidad eliminada correctamente');
        this.loadOportunidad(this.oportunidadId);
      }
    });
  }

  getOppSteps(){
    this.oppSteps = this.oppService.getOpportunitiesStep().find(s => s.step === this.currentStep);
  }

  getProspectStatus(){
    const data = {tipo:'OPP'};

    this.api.getStatusByType(data).subscribe({
      next: (data:any)=>{
        this.oppStatus = data.data;
      },
      error: (err:any)=>{
        console.error(err);
      }
    })
  }

  markStatus(status: string, index: number){
    if (this.markedStatus === status) {
      this.markedStatus = '';
      this.statusIndex = -1;
    } else {
      this.markedStatus = status;
      this.statusIndex = index;
    }
    console.log('Estado marcado:', this.markedStatus, this.statusIndex);
  }

  updateOpportunityStatus(){
    const data = { oportunidad_id: this.oportunidadId, id_estado: this.markedStatus};
    console.log('Datos para actualizar estado:', data);

    if(this.statusIndex === 4){
      this.openMdlCloseOpportunity();
      return;
    }else{
      this.api.updateOpportunityStatus(data).subscribe({
        next: (data:any)=>{
          console.log(data);
        this.alertService.success('Exito','progreso actualizado exitosamente')
        setTimeout(() => {
          window.location.reload();
        }, 1500);
        },
        error: (err: any) => {
        this.api.hideLoading();
        if (err?.status===403){
          this.alertService.error('Acceso denegado',"No tienes permiso para modificar prospectos.");
          return
        }
        this.alertService.error('Error','Ocurrió un problema al modificar el prospecto.')          
        },
      });
    }
  }

  openMdlCloseOpportunity() {
    this.dialog.open(MdlCloseOpportunity, {
      minWidth: '550px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create', 
        oportunidad_id: this.oportunidadId
      }
    });
  }


  togleSection(section: string){
    switch(section){
      case 'info':
        this.showInfoSection = !this.showInfoSection;
        break;
      case 'extra':
        this.showExtraSection = !this.showExtraSection;
        break;
      case 'other':
        this.showOtherSection = !this.showOtherSection;
        break;
      case 'history':
        this.showHistorySection = !this.showHistorySection;
        break;
    }
}

toggleEdit(section:'info' | 'extra'){
    switch(section){
      case 'info':
        this.editInfo = !this.editInfo;
        break;
      case 'extra':
        this.editExtra = !this.editExtra;
        break;
    }
    if (this.editInfo || this.editExtra) {
      this.editableOportunidad = { ...this.oportunidad };


  }
}


cancelEdit(section:'info' | 'extra'){
  if (section === 'info') this.editInfo = false;
  if (section === 'extra') this.editExtra = false;
  this.editableOportunidad ={...this.oportunidad};

}


saveEdit(section:'info' | 'extra'){
this.api.updateOportunidad(this.editableOportunidad).subscribe({
  next:(resp:any)=>{
    this.alertService.success('Actualización exitosa', 'Oportunidad actualizada correctamente');
    
    if (resp?.oportunidad) {
      this.oportunidad = resp.oportunidad;
      this.formatOportunidadData()
    }else{
     this.oportunidad ={...this.editableOportunidad}; 
     this.formatOportunidadData();
    }


    if (section === 'info') this.editInfo = false;
    if (section === 'extra') this.editExtra = false;
  },
  error:(err:any)=>{
    console.error(err);
    this.alertService.error('Error al actualizar', 'Error al actualizar la oportunidad');
      },
    });
  }

  openSendMail() {
    this.dialog.open(MdlSendMail, {
      minWidth: '750px',
      maxHeight: '700px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'add', // o 'edit'
        mailData: { // Datos iniciales opcionales
          from: 'usuario@empresa.com',
          asunto: 'Asunto predefinido'
        },
        destinatarios: ['cliente@empresa.com'],
        tipo: 'individual'
      }
    });
  }

  private formatDateString(fecha?: string): string {
    if (!fecha) return '';
    // fecha viene como "YYYY-MM-DD"
    const [y, m, d] = fecha.split('-');
    return `${d}/${m}/${y}`;
  }
  

}